import { createBreakpoints } from "@thebouqs/theme-tools";
/**
 * Breakpoints for responsive design
 */
// no longer necessary to include the array, or else it will duplicate the values

var breakpoints = ["30rem", "48rem", "62rem", "87.5rem"];
var breakpointsObj = {};
breakpointsObj.sm = breakpoints[0];
breakpointsObj.md = breakpoints[1];
breakpointsObj.lg = breakpoints[2];
breakpointsObj.xl = breakpoints[3];
export default createBreakpoints(breakpointsObj);
//# sourceMappingURL=breakpoints.js.map